import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Brand";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const t = new URLSearchParams(window.location.search).get("t");
  const [state, setState] = useState(t ? "loading" : "error");

  useEffect(() => {
    if (!t) return;
    axios.post(`${API}/newsletter/unsubscribe`, { t }).then(() => setState("done")).catch(() => setState("error"));
  }, [t]);

  const resubscribe = () => axios.post(`${API}/newsletter/resubscribe`, { t }).then(() => setState("back")).catch(() => setState("error"));

  const text = {
    loading: "Un instant…",
    done: "Vous ne recevrez plus nos e-mails d'offres. Votre abonnement n'est pas modifié : pour le résilier, utilisez « Gérer ou résilier mon abonnement ».",
    back: "C'est noté, vous recevrez à nouveau nos offres.",
    error: "Ce lien de désabonnement n'est pas valide.",
  }[state];

  return (
    <div className="min-h-screen bg-ivory">
      <header className="flex justify-center px-5 pb-4 pt-8 sm:pt-12"><Logo tone="dark" /></header>
      <main className="mx-auto max-w-xl px-4 pb-16 sm:px-6">
        <section data-testid="unsubscribe-page" className="rounded-[32px] bg-navy px-5 py-12 text-center sm:px-10">
          <h1 className="font-display text-3xl text-ivory sm:text-4xl">E-mails d'offres</h1>
          <p data-testid="unsubscribe-status" className="mt-5 text-base text-ivory/80">{text}</p>
          {state === "done" && (
            <button type="button" onClick={resubscribe} data-testid="resubscribe-button" className="btn-gold mt-8 justify-center px-8 py-3 text-sm">
              Me réabonner aux offres
            </button>
          )}
          <p className="mt-8 flex flex-wrap justify-center gap-6">
            <Link to="/mon-compte" data-testid="unsubscribe-account-link" className="text-sm text-ivory/70 underline underline-offset-4">Gérer ou résilier mon abonnement</Link>
            <Link to="/" data-testid="unsubscribe-home-link" className="text-sm text-ivory/70 underline underline-offset-4">Retour au site</Link>
          </p>
        </section>
      </main>
    </div>
  );
}
